import { QuickSellDetails } from "../../../dispatch/src/QuickSellDetails";
import { Button, DataSource, HorizontalSpacer, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfferOrder extends Layout {
    buttonBlastAllOffers: Button;
    horizontalspacer1: HorizontalSpacer;
    layoutQuickSellDetails: QuickSellDetails;
    sourceCarrierOfferGenerator: DataSource;
    sourceMovement: DataSource;
    tableOffers: Table;
}
